<template>
  <div>
    <bar-chart
      :chart-data="testData"
      style="height: 400px; postition: relative;"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "bar-chart": () =>
      import("@/components/common/charts/BarChart.vue"),
  },
  data() {
    return {
      testData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        datasets: []
      }
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    fetchData() {
      const data = {
        query: `
          query  {
            DevicesSoldYearStats(
              from: "${this.getThisYearRange[0]}",
              to: "${this.getThisYearRange[1]}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          let newData = {
            labels: [...this.testData.labels],
            datasets: JSON.parse(res.DevicesSoldYearStats)
          }
          this.testData = newData;
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      })  
    }
  },
  computed: {
    ...mapGetters(["getThisYearRange", "getUserSystem"])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
